import { render, staticRenderFns } from "./ElementDocComp.vue?vue&type=template&id=d125026e&"
import script from "./ElementDocComp.vue?vue&type=script&lang=js&"
export * from "./ElementDocComp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports